'use strict';

define('forum/topic', [
	'forum/infinitescroll',
	'forum/topic/threadTools',
	'forum/topic/postTools',
	'forum/topic/events',
	'forum/topic/posts',
	'forum/topic/replies',
	'components',
	'api',
	'alerts',
	'swiper',
	'native',
	'shopCode',
	'helpers',
	'forum/share',
	'forum/pullToRefresh',
	'ImageViewer',
], function (
	infinitescroll, threadTools, postTools, events, posts, replies,
	components, api, alerts, Swiper, native, shopCode,
	helpers, share, pullToRefresh, ImageViewer
) {
	const COMMUNITY_HOST = window.location.origin;
	// (window.COMMUNITY_URL[window.config.RTE][window.config.REGION] || '');
	const mediaMaxHeight = 470;
	const mediaMinHeight = 210;

	const Topic = {
		cid: null,
		tid: null,
		pid: null,
		user: {},
		mainPost: {},
		posts: [],
		total: null,
		page: null,
	};

	let mainPost;
	let container;
	let postsWrapper;
	let loading = false;

	$(window).on('action:ajaxify.start', function () {
		events.removeListeners();
	});

	Topic.init = function () {
		Topic.tid = ajaxify.data.tid;
		Topic.pid = ajaxify.data.pid;
		Topic.mainPost = {};
		Topic.posts = [];
		Topic.total = 0;
		Topic.page = 0;

		mainPost = $('#topicMainPost');
		container = $('.topic');
		postsWrapper = $('#topicPosts');

		if (native.mock) {
			$('.account-navbar').removeClass('hidden');
			$('#pageContent').addClass('mock-page');
		} else {
			$('#pageContent').removeClass('mock-page');
			native.didRender();
			native.updateStatusBarStyle();
		}

		app.enterRoom('topic_' + Topic.tid);

		$('#back').on('click', function () {
			if (window.location.search.indexOf('from=app') === -1) {
				window.history.go(-1);
			} else {
				window.location.href = 'https://close-community.aidot.com/close';
			}
		});

		mainPost.on('click', '.moment-single-image, .moment-multi-image .swiper-slide', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const currentImage = $(this).find('img');
			const images = [];
			const currentIndex = $(this).attr('index');
			if (currentIndex) {
				const imgs = $(this).parent().find('img');
				for (let i = 0; i < imgs.length; i += 1) {
					images.push(imgs[i].src);
				}
				ImageViewer.view(images, parseInt(currentIndex, 10));
			} else {
				for (let i = 0; i < currentImage.length; i += 1) {
					images.push(currentImage[i].src);
				}
				ImageViewer.view(images);
			}
		});

		mainPost.on('click', '[component="ballot-list"] .ballot-item', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const el = $(this).parents('ul.ballot-list');
			const deadline = el.find('[data-deadline]').attr('data-deadline');
			if (deadline < new Date()) {
				return;
			}
			const isMultiple = el.data('multiple');
			const pid = el.closest('[data-pid]').attr('data-pid');
			const ballotItem = $(this);
			const ballotId = ballotItem.data('ballot-index');
			if (isMultiple) {
				// 多选投票帖
				if (ballotItem.hasClass('ballot-item')) {
					if (ballotItem.hasClass('balloted')) {
						ballotItem.removeClass('balloted').find('.icon-nodeBB-icon_vote_up').addClass('hide');
					} else {
						ballotItem.addClass('balloted').find('.icon-nodeBB-icon_vote_up').removeClass('hide');
					}
					if (el.find('.balloted').length) {
						el.find('.ballot-btn').removeClass('disabled').addClass('valid');
					} else {
						el.find('.ballot-btn').removeClass('valid').addClass('disabled');
					}
				}
			} else if (ballotItem.hasClass('ballot-item')) {
				// 单选投票帖
				api.put(`/posts/${pid}/ballot`, {
					ids: [ballotId],
				}, function (err, data) {
					if (err) {
						if (err.message === 'A valid login session was not found. Please log in and try again.') {
							ajaxify.go('login');
							return;
						}
						return alerts.error(err);
					}
					renderBallotList(el, data);
				});
			}
		});

		mainPost.on('click', '.ballot-btn', function (e) {
			e.preventDefault();
			e.stopPropagation();
			if ($(this).hasClass('disabled')) {
				return;
			}
			const el = $(this).parents('ul.ballot-list');
			const pid = $(this).closest('[data-pid]').attr('data-pid');
			const items = $(this).siblings('li.balloted');
			const ids = [];
			items.each((i, item) => ids.push($(item).data('ballot-index')));
			api.put(`/posts/${pid}/ballot`, {
				ids,
			}, function (err, data) {
				if (err) {
					if (err.message === 'A valid login session was not found. Please log in and try again.') {
						ajaxify.go('login');
						return;
					}
					return alerts.error(err);
				}
				renderBallotList(el, data);
			});
		});

		mainPost.on('click', '.tags .topic-group', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const topicGroupId = $(this).attr('data-topicgroupid');
			if (topicGroupId) {
				if (!native.mock) {
					native.openWebView({
						url: `${COMMUNITY_HOST}/topic-groups/${topicGroupId}`,
						newWebViewCanBack: true,
						infuseJsBridge: true,
						navBar: {
							hidden: true,
						},
						backButton: {
							hidden: false,
						},
						closeButton: {
							hidden: true,
						},
					});
					return;
				}
				ajaxify.go(`${config.relative_path}/topic-groups/${topicGroupId}`);
			}
		});

		mainPost.on('click', '[component="post/content"] a', externalLinkClick);
		postsWrapper.on('click', '[component="post/content"] a', externalLinkClick);

		container.on('click', '[component="avatar"]', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const userslug = $(this).attr('data-userslug');
			if (userslug) {
				if (!native.mock) {
					native.openWebView({
						url: `${COMMUNITY_HOST}/user/${userslug}?tab=post`,
						newWebViewCanBack: true,
						infuseJsBridge: true,
						navBar: {
							hidden: true,
						},
						backButton: {
							hidden: false,
						},
						closeButton: {
							hidden: true,
						},
					});
					return;
				}
				ajaxify.go(`${config.relative_path}/user/${userslug}?tab=post`);
			}
		});

		postsWrapper.on('click', '.photos', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const images = (this.dataset.images || '').split(',');
			if (images.length > 0) {
				ImageViewer.view(images);
			}
		});

		handleRefresh();

		postTools.init(Topic.tid);
		threadTools.init(Topic.tid, container);
		events.init();

		// 分享
		share.init($('[component="topic"]'));
		if (!Topic.pid) {
			// 滚动加载更多
			infinitescroll.init(handleLoadMore);
			// 下拉刷新
			pullToRefresh.init(container, $(window), function (callback) {
				handleRefresh(callback);
			});
		} else {
			// 下拉事件监听，评论模式下先展开主贴内容，再绑定下拉事件
			const topic = document.querySelector('.topic');
			const wrap = topic.querySelector('.topic-content__wrap');
			if (topic && wrap) {
				const $topic = $(topic);
				const $wrap = $(wrap);
				const $ctx = $wrap.find('.topic-content');
				const $window = $(window);
				const distance = 80;

				$ctx.css({ position: 'absolute', right: 0, bottom: 0, left: 0 });
				$wrap.css({ height: 0 }).show();

				const axis = {};
				const touchEvents = {
					off: function () {
						$topic.off('touchstart', this.onTouchStart);
						$topic.off('touchmove', this.onTouchMove);
						$topic.off('touchend', this.onTouchEnd);
					},
					on: function () {
						touchEvents.off();
						$topic.on('touchstart', this.onTouchStart);
						$topic.on('touchmove', this.onTouchMove);
						$topic.on('touchend', this.onTouchEnd);
					},
					onTouchStart: function onTouchStart(e) {
						$wrap.show();
						const p = pullToRefresh.getTouchPosition(e);
						axis.start = p;
						axis.diffX = 0;
						axis.diffY = 0;
					},
					onTouchMove: function onTouchMove(e) {
						if (!axis.start) return false;
						if ($topic.scrollTop() > 0 || $window.scrollTop() > 0) return;

						const p = pullToRefresh.getTouchPosition(e);
						axis.diffX = p.x - axis.start.x;
						axis.diffY = p.y - axis.start.y;
						if (axis.diffY < 0) return;

						if (e.preventDefault) {
							e.preventDefault();
						}
						if (e.stopPropagation) {
							e.stopPropagation();
						}

						axis.diffY **= 0.8;

						$wrap.css({ height: axis.diffY });
					},
					onTouchEnd: function onTouchEnd() {
						axis.start = false;
						if (axis.diffY <= 0) return;

						if (Math.abs(axis.diffY) <= distance) {
							$wrap.animate({ height: 0 }, 200);
						} else {
							touchEvents.off();
							const height = $ctx.outerHeight();
							$wrap.animate({ height: height }, 200, () => {
								$wrap.removeAttr('style');
								$ctx.removeAttr('style');
								// 下拉刷新
								pullToRefresh.init(container, $(window), function (callback) {
									handleRefresh(callback);
								});
							});
						}
					},
				};

				touchEvents.on();
			}
		}
	};

	function renderBallotList(el, data) {
		if (data && data.items) {
			const count = data.items.reduce((prev, curr) => (prev + curr.count), 0);
			el.find('li').each((index, item) => {
				const ballotIndex = $(item).data('ballot-index');
				const foundItem = data.items.find((resItem, idx) => idx === ballotIndex);

				if (foundItem) {
					$(item).find('.ballot-item-count').html(foundItem.count).data('count', foundItem.count);
					$(item).find('.ballot-background').css({ width: helpers.percentWidth(foundItem.count, count), transition: 'width 1s' });

					if (foundItem.isBalloted) {
						$(item).addClass('balloted-item balloted').removeClass('ballot-item').find('.icon-nodeBB-icon_vote_up')
							.removeClass('hide');
					} else {
						$(item).addClass('balloted-item').removeClass('ballot-item');
					}
				}
			});

			const userCount = parseInt(el.find('.ballot-desc .ballot-count').data('count'), 10) + 1;
			el.find('.ballot-desc .ballot-count').html(helpers.formatComments(parseInt(data.ballotUserCount || userCount, 10))).data('count', parseInt(data.ballotUserCount || userCount, 10));
			el.find('.ballot-btn').removeClass('valid').addClass('disabled').hide();

			if (window.tracer) {
				const $post = el.closest('.mainPost') || $('.mainPost');
				window.tracer.track('ParticipateVote', {
					post_theme: $post.find('.topic-title').text().trim(),
					poster_id: $post.data('uid'),
				});
			}
		}
	}

	function handleRefresh(cb) {
		Topic.tid = ajaxify.data.tid;
		Topic.pid = ajaxify.data.pid;
		Topic.mainPost = {};
		Topic.posts = [];
		Topic.total = 0;
		Topic.page = 0;
		getMainPost();
		loadMorePosts({ cb });
	}

	function renderMainPost(data) {
		Topic.mainPost = data.mainPost;
		postTools.updatePostCount(data.postcount);
		// 内容外链点击跳转商城做特殊处理
		const findShopLink = function () {
			if (!shopCode.SHOP_HOST) {
				return false;
			}
			const links = $('.mainPost .content a');
			const shopLinks = links.filter((i, item) => (item.href || '').indexOf(shopCode.SHOP_HOST) > -1);
			return !!shopLinks.length;
		};

		const hasShopLink = findShopLink();
		if (hasShopLink) {
			shopCode.setSchedule();
		} else {
			shopCode.unsetSchedule();
		}

		new Swiper('.swiper', {
			loop: false, // 循环模式选项
			pagination: {
				el: '.swiper-pagination',
				type: 'fraction',
			},
			on: {
				touchMove: function (swiper, event) {
					if (event.stopPropagation) {
						event.stopPropagation();
					}
				},
			},
		});

		const multiImages = $('.mainPost .moment-multi-image img');
		for (let i = 0; i < multiImages.length; i += 1) {
			const imageHeight = $(multiImages[i]).height();
			if (imageHeight < 375) {
				$($(multiImages[i]).parent()).css({ display: 'flex' });
			} else {
				$($(multiImages[i]).parent()).css({ display: 'block' });
			}
		}
		const singleImages = $('.mainPost .moment-single-image img');
		for (let i = 0; i < singleImages.length; i += 1) {
			const imageHeight = $(singleImages[i]).height();
			if (imageHeight < mediaMinHeight) {
				$($(singleImages[i]).parent()).css({ height: `${mediaMinHeight}px` });
			} else if (imageHeight > mediaMaxHeight) {
				$($(singleImages[i]).parent()).css({ height: `${mediaMaxHeight}px` });
			}
		}

		const $ctx = $('.mainPost .content[component="post/content"]');
		$ctx.find('video.ql-video').videoPlayer({
			maxWidth: 'parent',
			maxHeight: 470,
		});
		$ctx.find('iframe.ql-video').attr({
			allowfullscreen: true,
			allow: 'fullscreen',
		});

		const contentWidth = $('.mainPost .content[component="post/content"]').innerWidth();
		$('.mainPost .content[component="post/content"]').find('.ql-image').each(function () {
			const ds = this.dataset;
			if (ds && ds.width && ds.height) {
				let w = Number(ds.width);
				let h = Number(ds.height);
				if (w > contentWidth) {
					h *= contentWidth / w;
					w = contentWidth;
				}
				$(this).css({ width: w, height: h });
			}
		});

		if (window.tracer) {
			const d = data;
			const c = data.mainPost.content;

			if (d.cid === 1) {
				window.tracer.track('PostDetail', {
					post_theme: d.title,
					tag_list: [],
					is_text_included: !!d.title,
					is_vote_post: 0,
					is_image_attached: !!(c.imageList && c.imageList.length),
					is_video_attached: !!(c.videoList && c.videoList.length),
				});
			} else if (d.cid === 2) {
				const isVote = !!((c.items && c.items.length));
				window.tracer.track('PostDetail', {
					post_theme: d.title,
					tag_list: d.tags.map(t => t.value),
					is_text_included: !!c.value,
					is_vote_post: isVote,
					is_image_attached: !!(!isVote && c.imageList && c.imageList.filter(i => i.isImage).length),
					is_video_attached: !!(!isVote && c.imageList && c.imageList.filter(i => !i.isImage).length),
				});
			}
		}
	}

	function renderPostsList(data, html) {
		posts.onTopicPageLoad(components.get('post'));
		Topic.posts = data.posts;
		// 跳转到comment位置
		if (window.location.search.indexOf('toComment=1') > -1) {
			const offsetTop = $('[component="post/comment-title"]').offset().top;
			const navbarHeight = $('.account-navbar').innerHeight();
			$(window).scrollTop(offsetTop - navbarHeight);
			let search = window.location.search.replace('toComment=1', '');
			if (search === '?') {
				search = '';
			}
			const url = window.location.pathname.slice(1) + search + window.location.hash;
			ajaxify.updateHistory(url, true);
		}

		if (Topic.pid) {
			const container = $('[component="topic"] [component="post/replies"]').eq(0);
			if (container) {
				replies.getReplies(Topic.pid, null, (err, repliesEl) => {
					if (!err && repliesEl) {
						container.html(repliesEl);
					} else {
						container.html('');
					}
				});
			}
		} else {
			html.find('[component="post/reply-count"]').each(function () {
				const btn = $(this);
				replies.init(btn);
				btn.on('click', function () {
					replies.init(btn, true);
				});
			});
		}

		html.find('.timeago').timeago();
	}

	function getMainPost() {
		api.get(`/topics/${Topic.tid}`, {}).then((res) => {
			app.parseAndTranslate('topic_mainPost', { ...ajaxify.data, ...res }, function (html) {
				$('.topic-main-post .topic-skeleton').addClass('hidden');
				mainPost.html(html);
				const topicE = $(`[component=topic][data-tid=${Topic.tid}]`);
				topicE.attr('data-username', res.mainPost.user.username);
				topicE.attr('data-email', res.mainPost.user.email);
				topicE.attr('data-timestamp', res.timestamp);
				html.find('.timeago').timeago();
				helpers.formatTimeItem($('.mainPost').find('.time-format'));
				renderMainPost(res);
			});
		});
	}

	function loadMorePosts({ cb }) {
		const params = {
			pid: Topic.pid,
			page: (Topic.page || 0) + 1,
		};

		loading = true;
		if (params.page > 1) {
			$('.comments-list .list-status__loading').show();
		}

		api.get(`/topics/${Topic.tid}/posts`, params).then((res) => {
			loading = false;
			$('.comments-list .topic-skeleton').addClass('hidden');
			Topic.total = res.total || 0;
			Topic.page = params.page;
			const currentList = Topic.posts;
			const newPosts = res.posts.filter(i => !currentList.find(j => j.pid === i.pid));
			if (newPosts.length > 0) {
				Topic.posts = [...currentList, ...newPosts];
				$('.empty-replies').addClass('hidden');
				app.parseAndTranslate('partials/topic/post', { ...ajaxify.data, posts: newPosts }, function (html) {
					$('.comments-list .list-status__loading').hide();
					if (cb) {
						postsWrapper.html(html);
						cb();
					} else {
						postsWrapper.append(html);
					}

					renderPostsList(res, html);

					if (Topic.total > 0 && Topic.total <= Topic.page * 20) {
						$('.list-status__nomore').show();
					} else {
						$('.list-status__nomore').hide();
					}
				});
			} else {
				$('.comments-list .list-status__loading').hide();
				if (Topic.total === 0) {
					$('.empty-replies').removeClass('hidden');
				}
				if (cb) {
					cb();
				}
			}
		}).catch((e) => {
			if (cb) {
				cb();
			}
			alerts.error(e);
		});
	}

	function handleLoadMore(direction) {
		if (direction < 0 || loading) {
			return;
		}

		if (typeof Topic.total === 'number' && typeof Topic.page === 'number' && Topic.total <= Topic.page * 20) {
			return;
		}

		$('.list-status__nomore').hide();
		$('.comments-list .list-status__loading').hide();
		loadMorePosts({});
	}

	let externalLinkDoing = false;
	async function externalLinkClick(e) {
		if (externalLinkDoing) {
			e.stopPropagation();
			e.preventDefault();
			return;
		}
		externalLinkDoing = true;
		setTimeout(() => {
			externalLinkDoing = false;
		}, 500);
		const href = this.getAttribute('href');
		if (!href || href === '#') {
			return;
		}
		e.stopPropagation();
		e.preventDefault();
		const isShopUrl = href.indexOf(shopCode.SHOP_HOST) > -1;
		if ((window.config.RTE === 'prod' || window.config.RTE === 'pre') && +window.config.REGION === 2 && isShopUrl) {
			const code = await shopCode.getShopCode();
			if (typeof code !== 'string') {
				return;
			}
			const url = `${href}${href.indexOf('?') > -1 ? '&' : '?'}code=${code}`;
			if (native.mock) {
				window.open(url, '_blank');
			} else {
				native.openWebView({
					url,
					infuseJsBridge: true,
					navBar: {
						title: 'Shop',
						backgroundColor: '#FFFFFF',
						backButtonColor: '#1F2429',
						titleColor: '#1F2429',
					},
					closeButton: {
						hidden: true,
					},
				});
			}
		} else if (native.mock) {
			window.open(href, '_blank');
		} else {
			native.openWebView({
				url: href,
				infuseJsBridge: true,
				navBar: {
					title: '',
					backgroundColor: '#FFFFFF',
					backButtonColor: '#1F2429',
					titleColor: '#1F2429',
				},
				closeButton: {
					hidden: true,
				},
			});
		}
	}
	return Topic;
});
